import * as React from 'react'
import { Text, TextName } from 'sdk/text/Text'
import { TechBenefitsCard } from '../../components/tech-benefits-card/TechBenefitsCard'
import ArrowIcon from '../../components/tech-benefits-card/assets/arrow.svg'

import styles from './style.module.scss'

export const TechBenefitsSection: React.FC = () => {
  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <Text type={TextName.H2}>Technology Benefits</Text>
        <Text type={TextName.Text}>
          Serving Pro Audio Automotive OEMs and Tier 1 suppliers through SDKs, platform middleware, and customizable
          modules
        </Text>
      </div>

      <div className={styles.cards}>
        <TechBenefitsCard
          title={
            <>
              <span>GPU</span> <span className={styles.titleBreak} />
              Capacity
            </>
          }
          body='Turn deployed GPUs into massively parallel audio processors'
          iconSrc={ArrowIcon}
        />
        <TechBenefitsCard
          title={
            <>
              <span>5X</span> <span className={styles.titleBreak} />
              Faster
            </>
          }
          body='Development compared to conventional approaches'
          iconSrc={ArrowIcon}
        />
        <TechBenefitsCard
          title={
            <>
              <span>Up to</span> <span className={styles.titleBreak} />
              75X
            </>
          }
          body='Acceleration for offline rendering, 10x for embedded integrations'
          iconSrc={ArrowIcon}
        />
      </div>
    </div>
  )
}
